import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfigService } from '@rxap/config';
import { Title } from '@angular/platform-browser';
import { KeycloakService } from 'eurogard-keycloak';
import { ThemeService } from 'angular-services/theme/theme.service';
import { XamarinNavigationService } from '../services/xamarin-navigation.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { EUROGARD_DATE_FORMATS } from 'angular-forms/date-format';
import {
  UserSettingsAccordionDataSource
} from 'angular-components/layout/default-header/user-profile-icon/user-settings/user-settings-accordion.data-source';

@Component({
  selector: 'eurogard-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ RouterOutlet ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: EUROGARD_DATE_FORMATS },
    UserSettingsAccordionDataSource,
  ],
})
export class AppComponent {

  constructor(
    config: ConfigService<any>,
    titleService: Title,
    @Inject(KeycloakService)
    protected readonly keycloak: KeycloakService,
    theme: ThemeService,
    private readonly xamarinNavigationService: XamarinNavigationService,
  ) {
    this.xamarinNavigationService.listenForXamarinNavigationEvents();
    if (config.get('app.name', null)) {
      titleService.setTitle(config.getOrThrow('app.name'));
    }
    theme.setDarkTheme(true, false);
  }

}
